import { fromUnixTime } from 'date-fns'
import format from 'date-fns/format'

export default (date) => {
  return date ? format(new Date(fromUnixTime(date)), 'yyyy-MM-dd HH:mm:ss') : null
}
